<script>
    import { onMount, onDestroy, getContext } from 'svelte';
    import { link, push, location } from 'svelte-spa-router';

    import REGISTER_CONFIG from 'configs/register';

    import infinityService from 'services/infinity';

    import authStore from 'stores/auth';
    import registerStore from 'stores/register';
    import customerStore from 'stores/customer';

    import Page from 'components/Page';
    import NavBar from 'components/NavBar';
    import Button from 'components/Button';
    import Lottie from 'components/Lottie';
    import { SupportModal, supportModalOptions } from 'components/SupportModal';
    import { ForgotPasswordModal, forgotPasswordModalOptions } from 'components/ForgotPasswordModal';
    import { PaymentModal, paymentModalOptions } from 'components/PaymentModal';
    import analyticsService from 'services/analytics';

    const { open } = getContext('simple-modal');

    function showPaymentModal() {
        open(PaymentModal, {}, paymentModalOptions);
    }

    export let params = {};

    let isLogin;
    let isForgotPassword;
    let isAbout;
    let isFootball;
    let username, password, emailAddress, errorMsg;
    let isLoading = false;
    let activeSlideId;
    let slideshowInterval;
    let progressBarElement;

    const SLIDE_WAIT_TIME_SECONDS = 25;
    const SLIDES = [
        {
            id: 0,
            title: 'Standard Credit',
            titleShort: 'SC',
            subtitle: 'Same Legacy, <span>New Freedom</span>',
            desc: 'Transforming traditional hire-purchase into modern lending, Standard Credit combines 80 years of legacy with cutting-edge technology to deliver fast, flexible and affordable cash loans that give you the freedom to spend your way.',
            cta: {
                label: 'Apply for Loan',
                action: () => {
                    push('/register');
                },
            },
        },
        // {
        //     id: 1,
        //     title: 'Loans',
        //     titleShort: 'Loans',
        //     subtitle: 'Get the right loan for your <span>family</span> or <span>small business</span>',
        //     desc: 'Standard Credit provides responsible loans to employees and small businesses through a completely web-based system.',
        //     cta: {
        //         label: 'Apply Now',
        //         action: () => {
        //             push('/register');
        //         },
        //     },
        // },
        // {
        //     id: 2,
        //     title: 'Shop Now, Pay Later',
        //     titleShort: 'Shop',
        //     subtitle: 'Get the products you need now and <span>pay over time</span>',
        //     desc: 'Standard Credit provides product financing through an online shop with a great variety of consumer goods.',
        //     cta: {
        //         label: 'Shop Now',
        //         url: 'https://mytfshop.com',
        //     },
        // },
        // {
        //     id: 3,
        //     title: 'TF Auto',
        //     titleShort: 'Auto',
        //     subtitle:
        //         'Borrow against your <span>existing vehicle</span> or borrow to <span>purchase a new vehicle</span>',
        //     desc: 'TF SME provides loans to customers who have equity in their existing vehicles, or loans to customers who are interested in purchasing a new vehicle. This product is available in T&T only.',
        //     cta: {
        //         label: 'Apply Now',
        //         url: 'https://mytermfinance.com/#/register?country=tt&type=3',
        //     },
        // },
        // {
        //     id: 4,
        //     title: 'Standard Credit City League',
        //     titleShort: 'Football',
        //     subtitle: 'Join us in shaping the <span>future of Caribbean football</span>',
        //     desc: 'Standard Credit proudly sponsors the Standard Credit City League, partnering with City F.C. to create a premier youth football program that develops talent while teaching discipline and integrity.',
        //     cta: {
        //         label: 'Learn More',
        //         action: () => {
        //             isLogin = false;
        //             setTimeout(() => (isFootball = true), isLogin ? 1000 : 0);
        //         },
        //     },
        // },
        // {
        //     id: 5,
        //     title: 'Financial Wellness',
        //     titleShort: 'Well',
        //     subtitle: 'Get financial guidance from <span>people who care</span>',
        //     desc: 'Standard Credit offers Financial Wellness seminars and personal consultations to our customers at no charge.',
        //     cta: {
        //         label: 'Learn More',
        //         url: 'https://wellness.mytermfinance.com',
        //     },
        // },
    ];

    onMount(() => {
        isAbout = false;
        isFootball = $location == '/football';
        isLogin = $location == '/login';
        isForgotPassword = $location == `/reset-password/${params.token}`;
        username = $registerStore[REGISTER_CONFIG.STEPS.CREDENTIALS.key].username;
        password = $registerStore[REGISTER_CONFIG.STEPS.CREDENTIALS.key].password;

        // Automatically log in the user if they just completed registering
        setTimeout(() => {
            if (username && password && $registerStore.isComplete) {
                $registerStore.reset();
                login();
            }
        }, 1000);

        // Start the slideshow
        activeSlideId = SLIDES[0].id;
        // startSlideshow();

        // Show forgot password modal
        if (isForgotPassword) {
            open(ForgotPasswordModal, { token: params.token }, forgotPasswordModalOptions);
        }
    });

    onDestroy(() => {});

    function startSlideshow() {
        slideshowInterval = setInterval(changeSlide, SLIDE_WAIT_TIME_SECONDS * 1000);
    }

    function changeSlide(slideId = null) {
        let nextSlideId;

        if (slideId != null) {
            clearInterval(slideshowInterval);
            activeSlideId = slideId;
            resetProgressBarAnimation();
            startSlideshow();
        } else {
            nextSlideId = activeSlideId + 1;
            activeSlideId = SLIDES[nextSlideId >= SLIDES.length ? 0 : nextSlideId].id;
        }
    }

    function resetProgressBarAnimation() {
        progressBarElement.classList.remove('split__progress--fill');
        progressBarElement.offsetHeight; /* trigger reflow */
        progressBarElement.classList.add('split__progress--fill');
    }

    function login() {
        isLoading = true;
        errorMsg = null;

        infinityService.login({ username, password }).then(
            (response) => {
                if (response.isSuccessful) {
                    authStore.setCustomerId(response.customerId);

                    // Fetch the rest of the customer details
                    customerStore.fetch(response.customerId).then(
                        () => {
                            push('/loans');
                        },
                        () => {
                            errorMsg = 'We were not able to log you in. Please contact support if this issue persists.';
                            isLoading = false;
                        },
                    );
                } else {
                    errorMsg = response.errorMsg;
                    isLoading = false;
                }
            },
            (error) => {
                console.error(error);
                isLoading = false;
            },
        );
    }
</script>

<NavBar
    on:login={() => (isLogin = true)}
    on:register={() => push('/register')}
    on:hpcustomers={() => push('/hp-customers')}
    on:servicewarranties={() => push('/service-warranties')}
/>
<div class="root">
    <div class="reveal animate__animated animate__slideOutLeft" />
    <Page>
        <div slot="content">
            <div class="split">
                <div class="split__container">
                    <div class="wrapper">
                        <!-- Mobile Video Background -->
                        <video class="split__video split__video--mobile" autoplay muted loop playsinline>
                            <source src="/videos/login_video.mov" type="video/mp4" />
                        </video>
                        <!-- Mobile Blue Overlay -->
                        <div class="split__video-overlay split__video-overlay--mobile"></div>
                        <!-- Login / Forgot Password -->
                        <div
                            class="slide-overlay slide-overlay--login animate__animated"
                            class:animate__slideInLeft={isLogin}
                            class:animate__slideOutLeft={!isLogin}
                        >
                            <div
                                class="slide slide--no-top slide--center animate__animated animate__fadeIn"
                                style="animation-delay: 1s;"
                            >
                                <div class="slide__content slide__content--compact">
                                    <div class="slide__header">
                                        <h1
                                            class="slide__title slide__title--no-margin slide__title--extra-line-height slide__title--light animate__animated animate__pulse"
                                        >
                                            Log in
                                        </h1>
                                        <div
                                            class="overlay-close-btn animate__animated animate__fadeIn"
                                            on:keydown
                                            on:click={() => {
                                                isLogin = false;
                                            }}
                                        >
                                            <Lottie jsonPath="/lottie/close_icon.json" loop={false} />
                                        </div>
                                    </div>
                                    <form class="login-form">
                                        {#if errorMsg}
                                            <div class="login-form__errors">{errorMsg}</div>
                                        {/if}
                                        {#if !isLoading}
                                            <div class="login-form__control">
                                                <input
                                                    autocomplete="off"
                                                    type="text"
                                                    class="login-form__input"
                                                    placeholder="Username"
                                                    bind:value={username}
                                                />
                                            </div>
                                            <div class="login-form__control">
                                                <input
                                                    autocomplete="off"
                                                    class="login-form__input"
                                                    type="password"
                                                    placeholder="Password"
                                                    bind:value={password}
                                                />
                                            </div>
                                        {:else}
                                            <div class="login-form__control animate__animated animate__bounceIn">
                                                <div class="login-form__loader">
                                                    <Lottie jsonPath="/lottie/loading-circle.json" />
                                                </div>
                                            </div>
                                        {/if}
                                        <div class="login-form__actions">
                                            <Button
                                                type="submit"
                                                primaryInverse
                                                fullWidth
                                                onClick={() => login()}
                                                isLoading
                                                disabled={isLoading || !username || !password}
                                            >
                                                {isLoading ? 'Logging in ...' : 'Log in'}
                                            </Button>
                                        </div>
                                        <div class="login-form__links">
                                            <div class="login-form__link">
                                                <div
                                                    on:keydown
                                                    on:click={() => {
                                                        open(ForgotPasswordModal, {}, forgotPasswordModalOptions);
                                                    }}
                                                >
                                                    I forgot my password
                                                </div>
                                            </div>
                                            <div class="login-form__link">
                                                Not a member?
                                                <a use:link href="/register">Register Today</a>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <!-- TF City Leauge -->
                        <div
                            class="slide-overlay slide-overlay--football animate__animated"
                            class:animate__slideInLeft={isFootball}
                            class:animate__slideOutLeft={!isFootball}
                        >
                            <div
                                class="slide slide--no-top slide--center animate__animated animate__fadeIn"
                                style="animation-delay: 1s;"
                            >
                                <div class="slide__content slide__content--compact slide__content--about">
                                    <div class="slide__header">
                                        <h1
                                            class="slide__title slide__title--no-margin slide__title--light slide__title--extra-line-height"
                                        >
                                            Standard Credit City League
                                        </h1>
                                        <div
                                            class="overlay-close-btn animate__animated animate__fadeIn"
                                            on:keydown
                                            on:click={() => (isFootball = false)}
                                        >
                                            <Lottie jsonPath="/lottie/close_icon.json" loop={false} />
                                        </div>
                                    </div>
                                    <p class="slide-overlay__p">
                                        Standard Credit proudly sponsors the Standard Credit City League, partnering
                                        with City F.C. to create a premier youth football program that develops talent
                                        while teaching discipline and integrity. Player registrations are available
                                        through our website, streamlining the process while supporting league
                                        operations.
                                    </p>
                                    <p class="slide-overlay__p">
                                        Join us in shaping the future of Caribbean football by registering today for
                                        this exciting tournament that nurtures young athletes both on and off the field!
                                    </p>
                                    <br />
                                    <Button
                                        primary
                                        medium
                                        onClick={() => {
                                            analyticsService.track(analyticsService.EVENTS.FOOTBALL_REGISTER, {});
                                            window.open('https://forms.gle/de4MS8LNNDjqVHQ49');
                                        }}
                                    >
                                        Register Today
                                    </Button>
                                </div>
                            </div>
                        </div>

                        <!-- About -->
                        <div
                            class="slide-overlay slide-overlay--about animate__animated"
                            class:animate__slideInLeft={isAbout}
                            class:animate__slideOutLeft={!isAbout}
                        >
                            <div
                                class="slide slide--no-top slide--center animate__animated animate__fadeIn"
                                style="animation-delay: 1s;"
                            >
                                <div class="slide__content slide__content--compact slide__content--about">
                                    <div class="slide__header">
                                        <h1
                                            class="slide__title slide__title--no-margin slide__title--light slide__title--extra-line-height animate__animated animate__pulse"
                                        >
                                            About
                                        </h1>
                                        <div
                                            class="overlay-close-btn animate__animated animate__fadeIn"
                                            on:keydown
                                            on:click={() => (isAbout = false)}
                                        >
                                            <Lottie jsonPath="/lottie/close_icon.json" loop={false} />
                                        </div>
                                    </div>
                                    <p class="slide-overlay__p">
                                        Standard Credit is a web-based lender operating across the Caribbean.
                                    </p>
                                    <p class="slide-overlay__p">
                                        Using a sophisticated tech-stack, we've processed over one hundred thousand
                                        loans and eCommerce "buy now, pay later" transactions without ever meeting a
                                        customer face-to-face.
                                    </p>
                                    <p class="slide-overlay__p">
                                        Standard Credit is owned by Trinidad & Tobago based PointWest Capital and First
                                        Citizens Bank.
                                    </p>
                                    <br />
                                    <Button
                                        primary
                                        medium
                                        onClick={() => {
                                            open(SupportModal, {}, supportModalOptions);
                                        }}
                                    >
                                        Contact us
                                    </Button>
                                </div>
                            </div>
                        </div>
                        {#each SLIDES as slide}
                            {#if activeSlideId == slide.id}
                                <div class="slide animate__animated animate__fadeIn">
                                    <div class="slide__content">
                                        <h1 id="slide__title" class="slide__title">
                                            {slide.title}
                                        </h1>
                                        <div class="slide__subtitle animate__animated animate__fadeIn">
                                            {@html slide.subtitle}
                                        </div>
                                        <div class="slide__desc animate__animated animate__fadeIn">
                                            {@html slide.desc}
                                        </div>
                                        <div class="slide__action-buttons animate__animated animate__fadeIn">
                                            <button
                                                class="action-button action-button--blue-1"
                                                on:click={() => push('/register')}
                                            >
                                                <img src="/images/icons/icon-apply.svg" alt="" class="action-button__icon" />
                                                <span>Apply for a Loan</span>
                                            </button>
                                            <button
                                                class="action-button action-button--blue-2"
                                                on:click={() => push('/hp-customers')}
                                            >
                                                <img src="/images/icons/icon-hp-customers.svg" alt="" class="action-button__icon" />
                                                <span>HP Customers</span>
                                            </button>
                                            <button
                                                class="action-button action-button--blue-3"
                                                on:click={() => push('/service-warranties')}
                                            >
                                                <img src="/images/icons/icon-warranties.svg" alt="" class="action-button__icon" />
                                                <span>Service & Warranties</span>
                                            </button>
                                            <button
                                                class="action-button action-button--blue-4"
                                                on:click={() => open(SupportModal, {}, supportModalOptions)}
                                            >
                                                <img src="/images/icons/icon-contact.svg" alt="" class="action-button__icon" />
                                                <span>Contact us</span>
                                            </button>
                                            <button
                                                class="action-button action-button--blue-5"
                                                on:click={showPaymentModal}
                                            >
                                                <img src="/images/icons/icon-payment.svg" alt="" class="action-button__icon" />
                                                <span>Make a Payment</span>
                                            </button>
                                            <button
                                                class="action-button action-button--blue-6"
                                                on:click={() => window.open('https://snapfi.standardtt.com', '_blank')}
                                            >
                                                <img src="/images/icons/icon-snapfi.svg" alt="" class="action-button__icon" />
                                                <span>SnapFi</span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            {/if}
                        {/each}
                        <!-- <div class="slide-icons">
                            {#each SLIDES as slide, i}
                                <div
                                    on:keypress
                                    on:click={() => changeSlide(slide.id)}
                                    class="slide-icons__icon"
                                    class:slide-icons__icon--active={activeSlideId == slide.id}
                                >
                                    <div class="slide-icons__label">{slide.titleShort}</div>
                                    <div class="slide-icons__animation">
                                        {#if slide.id != 4}
                                            <Lottie
                                                jsonPath={`/lottie/slide_${slide.id}_icon.json`}
                                                loop={activeSlideId == slide.id}
                                            />
                                        {:else}
                                            <span
                                                ><i
                                                    class="fa-duotone fa-regular fa-goal-net"
                                                    style="--fa-primary-color: #5426a3; --fa-secondary-color: #5426a3;"
                                                ></i></span
                                            >
                                        {/if}
                                    </div>
                                </div>
                                {#if i < SLIDES.length - 1}
                                    <div class="slide-icons__divider" />
                                {/if}
                            {/each}
                        </div> -->
                        <div class="split__progress" />
                        <div
                            bind:this={progressBarElement}
                            class="split__progress split__progress--fill"
                            style={`animation-duration: ${SLIDE_WAIT_TIME_SECONDS}s`}
                        />
                    </div>
                </div>
                <div class="split__container split__container--bg">
                    <div
                        style="width: 100%; height: 100%; position: absolute; top: 0; left: 0; opacity: 0.5; z-index: 10;"
                    >
                        <Lottie jsonPath="/lottie/circle_bg.json" />
                    </div>
                    <div class="wrapper wrapper--justify-start wrapper--reverse">
                        <!-- <nav class="nav nav--reverse">
                            <div class="nav__links nav__links--small-gap">
                                <div class="nav__link">
                                    <Button
                                        secondaryInverse
                                        small
                                        disabled={isLogin}
                                        onClick={() => {
                                            open(SupportModal, {}, supportModalOptions);
                                        }}
                                    >
                                        Contact Us
                                    </Button>
                                </div>
                                <div class="nav__link">
                                    <Button
                                        primary
                                        small
                                        disabled={isLogin}
                                        onClick={() => {
                                            setTimeout(() => (isLogin = true), isAbout ? 1000 : 0);
                                            isAbout = false;
                                        }}
                                    >
                                        Log In / Register
                                    </Button>
                                </div>
                            </div>
                        </nav> -->
                    </div>
                    <!-- Video Background -->
                    <video class="split__video" autoplay muted loop playsinline>
                        <source src="/videos/login_video.mov" type="video/mp4" />
                    </video>
                    <!-- Blue Overlay -->
                    <div class="split__video-overlay"></div>
                </div>
            </div>
        </div>
    </Page>
</div>

<style lang="scss" type="text/scss">
    @use 'src/sass/base' as *;

    .root {
        background: $color-primary;
        height: 100vh;
        overflow: scroll;
    }

    .reveal {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 999999999;
        background: $color-primary;
        animation-duration: 0.5s;
        animation-delay: 0.25s;
    }

    .split {
        // Mobile
        display: flex;
        flex: 1;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 100vh;
        background: $color-secondary;

        &__container {
            overflow: hidden;
            z-index: 2;
            position: relative;
            display: flex;
            flex-flow: column nowrap;
            flex: 1;
            position: relative;
            width: 60%;
            height: 100%;
            background: url('/images/login_bg.png') no-repeat center right;
            background-size: cover;
            box-shadow:
                rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
                rgba(0, 0, 0, 0.06) 0px 2px 4px -1px;

            &--bg {
                // Mobile
                display: none;

                overflow: hidden;
                position: relative;
                z-index: 1;
                justify-content: flex-start;
                align-items: center;
                max-width: 800px;
                animation: fadeIn;
                animation-duration: 2s;
            }
        }

        &__bg {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-repeat: no-repeat;
            background-position: center;
            background-size: cover;

            &--mobile {
                display: block;
            }

            &--overlay {
                display: block;
                z-index: 10;
                background: rgba($color-black, 0.3);
            }
        }

        &__video {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
            z-index: 1;

            &--mobile {
                display: block;
            }
        }

        &__video-overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.7);
            z-index: 2;

            &--mobile {
                display: block;
            }
        }

        @keyframes progress {
            from {
                height: 0;
            }
            to {
                height: 100%;
            }
        }

        &__progress {
            position: absolute;
            z-index: 50;
            top: 0;
            right: 0;
            width: 5px;
            height: 100%;
            background: darken($color-secondary, 5%);

            &--fill {
                animation-name: progress;
                animation-direction: normal;
                animation-iteration-count: infinite;
                background: $color-primary;
                animation-timing-function: ease-in-out;
            }
        }

        @include for-tablet-landscape-up {
            &__container {
                &--bg {
                    display: flex;
                }
            }

            &__bg {
                &--mobile {
                    display: none;
                }

                &--overlay {
                    display: none;
                }
            }

            &__video {
                &--mobile {
                    display: none;
                }
            }

            &__video-overlay {
                &--mobile {
                    display: none;
                }
            }
        }
    }

    .wrapper {
        display: flex;
        flex-flow: column nowrap;
        justify-content: flex-start;
        align-items: center;
        flex: 1;
        width: 100%;
        padding: em(25);
        font-family: $ff-headers;

        &--justify-start {
            justify-content: flex-start;
        }
    }

    .nav {
        // Mobile
        justify-content: space-between;

        position: relative;
        z-index: 1000;
        display: flex;
        flex-flow: row nowrap;
        align-items: center;
        width: 100%;
        min-height: 60px;

        &--reverse {
            justify-content: flex-end;
        }

        &__logo {
            display: none;
            white-space: nowrap;
            // margin-right: em(50);
            min-width: 60px;

            img {
                max-width: none;
            }

            &--mobile {
                display: block;
            }

            &--about {
                display: none;
            }
        }

        &__links {
            // Mobile
            display: none;

            column-gap: em(35);
            color: $color-black;

            &--small-gap {
                column-gap: em(15);
            }

            &--white {
                color: $color-white;
            }
        }

        &__link {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: em(16);
            color: inherit;
            cursor: pointer;

            &--mobile {
                margin-left: em(15);
                display: flex;
            }
        }

        &__mobile-links {
            display: flex;
            flex-flow: row nowrap;
        }

        @include for-tablet-portrait-up {
            justify-content: flex-start;
            flex-flow: row nowrap;

            &__logo {
                margin-right: em(50);
            }

            &--reverse {
                justify-content: flex-end;
            }

            &__links {
                display: flex;
                color: $color-white;
            }

            &__link {
                &--mobile {
                    display: none;
                }
            }
        }

        @include for-tablet-landscape-up {
            &__logo {
                display: block;

                &--mobile {
                    display: none;
                }
            }

            &__link {
                &--mobile {
                    display: none;
                }
            }

            &__links {
                color: $color-black;

                &--white {
                    color: $color-white;
                }
            }
        }
    }

    .slide {
        // Mobile
        top: em(-25);
        padding: 0 em(10);

        position: relative;
        z-index: 10;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 100%;

        &--center {
            justify-content: center;
            align-items: center;
            padding: 0;
        }

        &--no-top {
            top: em(0);
        }

        &__content {
            width: 100%;

            &--compact {
                width: 100%;
                max-height: 95vh;
                max-width: em(700);
            }
        }

        &__header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: em(25);
        }

        &__title {
            // Mobile
            font-size: em(48);
            line-height: 1;
            margin-bottom: em(20);

            display: block;
            margin-bottom: em(8);
            font-weight: $fw-bold;
            line-height: 1;
            color: $color-primary;
            animation-iteration-count: infinite;
            animation-duration: 4s;

            &--light {
                color: $color-white !important;
            }

            &--no-margin {
                margin-bottom: 0;
            }

            &--extra-line-height {
                line-height: 1.3;
            }
        }

        &__subtitle {
            // Mobile
            font-size: em(28);

            color: $color-secondary;
            margin-bottom: em(15);
            font-weight: $fw-regular;
            line-height: 1.1;
            animation-delay: 0.5s;
        }

        &__desc {
            // Mobile
            // display: none;
            font-size: em(18);
            color: $color-secondary;

            margin-bottom: em(20);
            font-family: $ff-primary;
            font-weight: $fw-light;
            line-height: 1.4;
            animation-delay: 0.9s;
        }

        &__cta {
            animation-delay: 1.2s;
        }

        &__action-buttons {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: em(12);
            animation-delay: 1.2s;
            max-width: em(600);

            @include for-tablet-portrait-up {
                gap: em(18);
            }

            @include for-tablet-landscape-up {
                gap: em(20);
            }
        }

        @include for-tablet-portrait-up {
            top: 0;
            max-width: em(800);
            padding: 0 em(40);

            &__content {
                &--compact {
                    margin-top: 0;
                }
            }

            &__title {
                margin-bottom: em(3);
                font-size: em(72);
                line-height: 1.1;
            }

            &__subtitle {
                margin-bottom: em(5);
                font-size: em(42);
            }

            &__desc {
                display: block;
                font-size: em(24);
            }
        }

        @include for-tablet-landscape-up {
            max-width: none;

            &__title {
                background: linear-gradient(119deg, rgb(01, 126, 202) 0%, rgb(14, 97, 165) 100%);
                background-clip: text;
                -webkit-text-fill-color: transparent;

                &--extra-line-height {
                    line-height: 1.3;
                }

                &--light {
                    color: $color-white !important;
                    background-clip: none;
                    -webkit-text-fill-color: $color-white;
                }
            }

            &__subtitle {
                color: $color-black;
            }

            &__desc {
                color: $color-gray-text;
            }
        }
    }

    .action-button {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: em(10);
        padding: em(20) em(8);
        border: none;
        border-radius: em(16);
        font-family: $ff-headers;
        font-size: em(12.5);
        font-weight: $fw-bold;
        color: $color-white;
        background: $color-primary;
        cursor: pointer;
        transition: all 0.25s ease;
        box-shadow: 0 2px 8px rgba(0, 126, 202, 0.2);

        span {
            text-align: center;
            line-height: 1.1;
            white-space: nowrap;
            padding: 0 em(3);
        }

        &:hover {
            transform: translateY(-2px);
            box-shadow: 0 6px 16px rgba(0, 126, 202, 0.3);
            background: darken($color-primary, 5%);
        }

        &:active {
            transform: translateY(0);
            box-shadow: 0 2px 8px rgba(0, 126, 202, 0.2);
        }

        // Different blue shades
        &--blue-1 {
            background: #007eca; // Primary brand blue
            box-shadow: 0 2px 8px rgba(0, 126, 202, 0.25);

            &:hover {
                background: darken(#007eca, 5%);
                box-shadow: 0 6px 16px rgba(0, 126, 202, 0.35);
            }
        }

        &--blue-2 {
            background: #0089e8; // Lighter bright blue
            box-shadow: 0 2px 8px rgba(0, 137, 232, 0.25);

            &:hover {
                background: darken(#0089e8, 5%);
                box-shadow: 0 6px 16px rgba(0, 137, 232, 0.35);
            }
        }

        &--blue-3 {
            background: #0561a5; // Darker ocean blue
            box-shadow: 0 2px 8px rgba(5, 97, 165, 0.25);

            &:hover {
                background: darken(#0561a5, 5%);
                box-shadow: 0 6px 16px rgba(5, 97, 165, 0.35);
            }
        }

        &--blue-4 {
            background: #00a3d9; // Cyan blue
            box-shadow: 0 2px 8px rgba(0, 163, 217, 0.25);

            &:hover {
                background: darken(#00a3d9, 5%);
                box-shadow: 0 6px 16px rgba(0, 163, 217, 0.35);
            }
        }

        &--blue-5 {
            background: linear-gradient(135deg, #d946ef 0%, #a855f7 100%); // Vibrant purple/magenta gradient
            box-shadow: 0 2px 8px rgba(168, 85, 247, 0.4);

            &:hover {
                background: linear-gradient(135deg, #c026d3 0%, #9333ea 100%);
                box-shadow: 0 6px 16px rgba(168, 85, 247, 0.5);
            }
        }

        &--blue-6 {
            background: linear-gradient(135deg, #0090d9 0%, #0052a3 100%);
            box-shadow: 0 2px 8px rgba(0, 82, 163, 0.4);

            &:hover {
                background: linear-gradient(135deg, #007eca 0%, #004090 100%);
                box-shadow: 0 6px 16px rgba(0, 82, 163, 0.5);
            }
        }

        &__icon {
            width: em(28);
            height: em(28);
        }

        @include for-tablet-portrait-up {
            font-size: em(15);
            padding: em(28) em(24);
            gap: em(14);

            &__icon {
                width: em(36);
                height: em(36);
            }

            span {
                white-space: normal;
            }
        }

        @include for-tablet-landscape-up {
            font-size: em(16);
            padding: em(32) em(28);

            &__icon {
                width: em(40);
                height: em(40);
            }
        }
    }

    .slide-icons {
        // Mobile
        top: em(-125);
        justify-content: center;
        padding: 0;

        position: relative;
        z-index: 10;
        display: flex;
        align-items: center;
        width: 100%;

        &__icon {
            display: flex;
            flex-flow: column nowrap;
            align-items: center;
            opacity: 1;
            cursor: pointer;

            &--active {
                animation: bounceIn;
                animation-duration: 2s;
                opacity: 1;
            }

            &:hover {
                opacity: 1;
                animation: pulse;
                animation-duration: 0.25s;
            }
        }

        &__label {
            margin-bottom: em(10);
            font-size: em(12);
            color: $color-white;
            white-space: nowrap;
        }

        &__animation {
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 35px;
            height: 35px;
            padding: em(5);
            background: rgba($color-secondary, 0.8);
            border: 1px solid $color-primary;
            border-radius: 50%;
        }

        &__divider {
            position: relative;
            top: 8px;
            width: 50px;
            height: 2px;
            background: $color-white;
            opacity: 0.25;
        }

        @include for-tablet-portrait-up {
            top: 0;
        }

        @include for-tablet-landscape-up {
            justify-content: flex-start;
            padding: 0 em(40);

            &__icon {
                background: transparent;
                opacity: 0.5;

                &--active {
                    animation: bounceIn;
                    animation-duration: 2s;
                    opacity: 1;
                }
            }

            &__divider {
                background: $color-primary;
                opacity: 0.5;
            }

            &__label {
                color: $color-gray-text;
            }
        }
    }

    .slide-overlay {
        // Mobile
        width: 100%;
        padding: 0 em(25);
        overflow-y: scroll;

        display: flex;
        flex: 1;
        justify-content: center;
        align-items: center;
        position: absolute;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 100;
        background: $color-primary;
        background-size: cover;
        box-shadow:
            rgba(0, 0, 0, 0.25) 0px 54px 55px,
            rgba(0, 0, 0, 0.12) 0px -12px 30px,
            rgba(0, 0, 0, 0.12) 0px 4px 6px,
            rgba(0, 0, 0, 0.17) 0px 12px 13px,
            rgba(0, 0, 0, 0.09) 0px -3px 5px;
        animation-duration: 0.25s;

        &--login {
            background: url('/images/login_form_bg.png') no-repeat center;
            background-size: cover;
        }

        &--about {
            z-index: 2000;
            background: url('/images/about_us_bg.png') no-repeat center;
            background-size: cover;
        }

        &--football {
            z-index: 2000;
            background: url('/images/football_bg.png') no-repeat center;
            background-size: cover;
        }

        &__p {
            margin-bottom: em(20);
            line-height: 1.2;
            font-family: $ff-primary;
            font-size: em(20);
            font-weight: $fw-light;
            color: $color-secondary;
        }

        @include for-tablet-portrait-up {
            overflow-y: auto;

            &--about {
                z-index: 100;
            }
        }

        @include for-tablet-landscape-up {
            width: 98%;
            padding: 0;

            &--login {
                background: url('/images/login_form_bg.png') no-repeat center;
                background-size: cover;
            }

            &--about {
                background: url('/images/about_us_bg.png') no-repeat center;
                background-size: cover;
            }
        }
    }

    .login-form {
        width: 100%;

        &__errors {
            margin: em(25) 0;
            font-family: $ff-primary;
            font-size: em(24);
            color: $color-white;
        }

        &__control {
            display: flex;
            flex-flow: column nowrap;
            justify-content: flex-start;
            align-items: center;
            margin: em(10) 0;
        }

        &__actions {
            margin: em(15) 0;
        }

        &__input {
            width: 100%;
            margin: 0;
            padding: em(13) em(15);
            outline: none;
            border: none;
            border-radius: em(22);
            box-shadow: none;
            background: rgba($color-white, 0.2);
            font-size: em(20);
            font-weight: $fw-regular;
            color: $color-white;
            cursor: pointer;

            &::placeholder {
                color: $color-secondary;
                opacity: 0.5;
            }

            &:focus {
                animation: pulse;
                animation-duration: 0.25s;
            }

            &:hover {
                background: rgba($color-white, 0.3);
            }
        }

        &__links {
            margin-top: em(50);
        }

        &__link {
            font-size: em(20);
            font-weight: $fw-light;
            color: $color-secondary;

            a,
            div {
                display: inline-block;
                margin-bottom: em(10);
                font-weight: $fw-bold;
                color: $color-white;
                cursor: pointer;

                &:hover {
                    animation: pulse;
                    animation-duration: 0.25s;
                    color: #cf57ff;
                }
            }
        }

        &__loader {
            display: flex;
            justify-items: center;
            align-items: center;
            width: 100px;
        }
    }

    .overlay-close-btn {
        position: relative;
        z-index: 2000;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        width: 50px;
        cursor: pointer;

        &:hover {
            animation: pulse;
            animation-duration: 0.25s;
            animation-iteration-count: infinite;
        }
    }
</style>
